import { configureStore } from "@reduxjs/toolkit"
import cartReducer from "./slices/CartSlice";

const Store = configureStore({
    reducer: {
      cartlists: cartReducer,
    },
  });
  
  export default Store;